// Maps IANA time zone identifiers (what the browser reports via Intl) to the Windows time zone IDs
// the backend (.NET) expects, e.g. `Eastern Standard Time`. Windows IDs are the same year-round, so
// this is DST-safe. Only the North American zones this application realistically sees are included —
// extend as needed.
const IANA_TO_WINDOWS_TIME_ZONE = new Map<string, string>([
  ['America/St_Johns', 'Newfoundland Standard Time'],
  ['America/Halifax', 'Atlantic Standard Time'],
  ['America/Glace_Bay', 'Atlantic Standard Time'],
  ['America/Moncton', 'Atlantic Standard Time'],
  ['America/Goose_Bay', 'Atlantic Standard Time'],
  ['America/Toronto', 'Eastern Standard Time'],
  ['America/Montreal', 'Eastern Standard Time'],
  ['America/Nipigon', 'Eastern Standard Time'],
  ['America/Thunder_Bay', 'Eastern Standard Time'],
  ['America/Iqaluit', 'Eastern Standard Time'],
  ['America/New_York', 'Eastern Standard Time'],
  ['America/Detroit', 'Eastern Standard Time'],
  ['America/Winnipeg', 'Central Standard Time'],
  ['America/Rainy_River', 'Central Standard Time'],
  ['America/Rankin_Inlet', 'Central Standard Time'],
  ['America/Resolute', 'Central Standard Time'],
  ['America/Chicago', 'Central Standard Time'],
  ['America/Regina', 'Canada Central Standard Time'],
  ['America/Swift_Current', 'Canada Central Standard Time'],
  ['America/Edmonton', 'Mountain Standard Time'],
  ['America/Cambridge_Bay', 'Mountain Standard Time'],
  ['America/Yellowknife', 'Mountain Standard Time'],
  ['America/Inuvik', 'Mountain Standard Time'],
  ['America/Denver', 'Mountain Standard Time'],
  ['America/Dawson_Creek', 'US Mountain Standard Time'],
  ['America/Fort_Nelson', 'US Mountain Standard Time'],
  ['America/Phoenix', 'US Mountain Standard Time'],
  ['America/Vancouver', 'Pacific Standard Time'],
  ['America/Whitehorse', 'Pacific Standard Time'],
  ['America/Dawson', 'Pacific Standard Time'],
  ['America/Los_Angeles', 'Pacific Standard Time']
]);

// Used when the system's zone is not in the map, since most users are in Saskatchewan/Central.
const DEFAULT_WINDOWS_TIME_ZONE = 'Central Standard Time';

export class TimeZoneUtils {
  // Returns the Windows time zone ID for the system's current IANA zone, falling back to Central
  // Standard Time when the zone is not mapped.
  public static getSystemWindowsTimeZone(): string {
    const ianaZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return IANA_TO_WINDOWS_TIME_ZONE.get(ianaZone) ?? DEFAULT_WINDOWS_TIME_ZONE;
  }
}
